import { NumberField, NumberFieldProps } from '@cademy-ui/form';
import { FunctionComponent } from 'react';

export type CustomNumberFieldProps = NumberFieldProps;

export const CustomNumberField: FunctionComponent<CustomNumberFieldProps> = (props) => {
    return <NumberField {...props} />;
};
